<div class="error-wrapper">
  <mat-card class="error-card">
    <div class="layout">
      <mat-icon class="error-icon">error_outline</mat-icon>
      <h2>Qualcosa è andato storto!</h2>
      <h4>Ci scusiamo per l'inconveniente.</h4>
      <button
        mat-flat-button
        color="primary"
        (click)="goHome()"
        class="mv-1"
      >
        <mat-icon>home</mat-icon>
        Torna alla home
      </button>
    </div>
  </mat-card>
</div>
